<template>
    <Head title="Blockchain"/>

    <authenticated-layout :notifications="notifications" >

        <template #header>
        </template>


        <div class="flex flex-col gap-6 p-6">

            <div class="grid grid-cols-2 gap-6 items-start">

                <div class="flex flex-col gap-6">

                    <div
                        v-if="access('blockchain', 'load_block')"
                        class="bg-white p-4 rounded flex flex-col gap-2"
                    >
                        <h2>Подгрузка блоков</h2>

                        <v-select label="Сеть" v-model="loadBlock.network" :error="loadBlock.errors.network">
                            <option v-for="network in networks">{{ network }}</option>
                        </v-select>
                        <v-input label="Номер" v-model="loadBlock.block" :error="loadBlock.errors.block" />
                        <v-input label="Хэш" v-model="loadBlock.hash" :error="loadBlock.errors.hash" />
                        <div class="flex justify-end">
                            <v-button type="button" class="text-right" color="blue"
                                      @click="loadBlock.post(this.route('blockchain.load-block'))"
                            >Выполнить</v-button>
                        </div>
                    </div>

                    <div
                        v-if="access('blockchain', 'call_approve')"
                        class="bg-white p-4 rounded flex flex-col gap-2"
                    >
                        <h2>Call Approve</h2>

                        <div class="grid grid-cols-3 gap-4 items-center">
                            <v-select label="Монета" v-model="callApprove.coin" :error="callApprove.errors.coin" >
                                <option v-for="currency in currencies">{{ currency }}</option>
                            </v-select>
                            <v-input class="col-span-2" label="Опер" v-model="callApprove.operAccount" :error="callApprove.errors.operAccount" />
                        </div>
                        <v-input label="Адрес" v-model="callApprove.address" :error="callApprove.errors.address" />
                        <div class="flex justify-end">
                            <v-button type="button" class="text-right" color="blue"
                                      @click="callApprove.post(this.route('blockchain.call-approve'))"
                            >Выполнить</v-button>
                        </div>
                    </div>


                    <div
                        v-if="access('blockchain', 'push_transaction')"
                        class="bg-white p-4 rounded flex flex-col gap-2"
                    >
                        <h2>Проталкивание транзакции</h2>

                        <v-select label="Сеть" v-model="pushTransaction.network" :error="pushTransaction.errors.network">
                            <option v-for="network in networks">{{ network }}</option>
                        </v-select>
                        <v-input label="Хэш" v-model="pushTransaction.hash" :error="pushTransaction.errors.hash" />
                        <v-input label="Gas price (gwei)" v-model="pushTransaction.gasPrice" :error="pushTransaction.errors.gasPrice" />
                        <div class="flex justify-end">
                            <v-button type="button" class="text-right" color="blue"
                                      @click="pushTransaction.post(this.route('blockchain.push-transaction'))"
                            >Выполнить</v-button>
                        </div>
                    </div>

                </div>

                <div class="flex flex-col gap-6">

                    <div
                        v-if="access('blockchain', 'make_transaction')"
                        class="bg-white p-4 rounded flex flex-col gap-2"
                    >

                        <h2>TransactionFromTo</h2>

                        <v-input label="Адрес отправителя" v-model="makeTransaction.addressFrom" :error="makeTransaction.errors.addressFrom" />
                        <v-input label="Адрес получателя" v-model="makeTransaction.addressTo" :error="makeTransaction.errors.addressTo" />
                        <div class="grid grid-cols-3 gap-4">
                            <v-select label="Сеть" v-model="makeTransaction.network" :error="makeTransaction.errors.network">
                                <option v-for="network in networks">{{ network }}</option>
                            </v-select>
                            <v-select label="Монета" v-model="makeTransaction.coin" :error="makeTransaction.errors.coin" >
                                <option v-for="currency in currencies">{{ currency }}</option>
                            </v-select>
                            <v-input label="Количество" type="number" v-model="makeTransaction.value" :error="makeTransaction.errors.value" />
                        </div>
                        <div class="grid grid-cols-3 gap-4 items-center">
                            <v-input label="2FA код" v-model="makeTransaction.secret" :error="makeTransaction.errors.secret" />
                            <v-toggle label="payFee" v-model="makeTransaction.payFee" :error="makeTransaction.errors.payFee" />
                        </div>
                        <div class="flex justify-end">
                            <v-button type="button" class="text-right" color="blue"
                                      @click="makeTransaction.post(this.route('blockchain.make-transaction'))"
                            >Выполнить</v-button>
                        </div>
                    </div>

                    <div
                        v-if="access('blockchain', 'staking')"
                        class="bg-white p-4 rounded flex flex-col gap-2"
                    >
                        <h2>Staking TRX</h2>
                        <v-input label="Адрес" v-model="staking" />
                        <div class="flex justify-end">
                            <v-button type="button" class="text-right" color="blue" :disabled="staking === ''"
                                      @click="useForm({}).get(this.route('blockchain.staking', ['tron', staking]))"
                            >Открыть</v-button>
                        </div>
                    </div>

                </div>

            </div>


        </div>

    </authenticated-layout>

</template>

<script>
import {Head, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VInput from "@/Components/Input";
import VButton from "@/Components/Button";
import VSelect from "@/Components/Select";
import VToggle from "@/Components/Toggle";
import Pagination from "@/Components/Pagination";

export default {
    components: {
        Head,
        AuthenticatedLayout,
        VInput,
        VButton,
        VSelect,
        VToggle,
        Pagination,
    },
    props: {
        notifications: Object,
        currencies: Object,
        networks: Object,
    },
    data() {
        return {
            'staking': '',
            'resources': ['energy', 'bw', 'power'],
            'resourcePage': 'delegate',
            'delegateResource': {
                'address': '',
                'network': 'tron',
                'receiver': '',
                'resource': 'energy',
                'amount': 0,
                'errors': {},
            },
            'reclameResource': {
                'address': '',
                'network': 'tron',
                'receiver': '',
                'resource': 'energy',
                'amount': 0,
                'errors': {},
            },
        }
    },
    methods: {
        useForm,
        sendResource(route, param) {
            param.errors = {};
            const { address, network, receiver, resource, amount } = param;

            axios.post(route, { address, network, receiver, resource, amount: `${amount}` })
                .then(res => {
                    param.address = '';
                    param.receiver = '';
                    param.amount  = 0;
                    this.notifications.push(...res.data.notifications)
                })
                .catch(err => {
                    if(err.response.status === 422) {
                        param.errors = err.response.data.errors;
                    } else this.notifications.push({ type: 'error', title: `Error ${err.response.status}`, message: err.response.data })
                });
        },
    },
    setup () {
        const loadBlock = useForm({
            'network': '',
            'block': '',
            'hash': '',
        });
        const makeTransaction = useForm({
            'coin': '',
            'network': '',
            'addressFrom': '',
            'addressTo': '',
            'value': '',
            'payFee': null,
            'secret': '',
        });
        const pushTransaction = useForm({
            'network': '',
            'hash': '',
            'gasPrice': '',
        })
        const callApprove = useForm({
            'coin': '',
            'address': '',
            'operAccount': '',
        })
        return { loadBlock, makeTransaction,  pushTransaction, callApprove }
    },
}
</script>
